import styled, { css } from "styled-components";

interface IWithState {
  state: "available" | "occupied" | "maintenance" | "reserved";
  isReserved: boolean;
}

export const Container = styled.div`
  .addButton {
    color: var(--primary-color);
    border: 1px solid var(--primary-color);
    border-radius: 100%;
    background-color: transparent;
    width: 20px;
    height: 20px;
    margin-top: 5px;
  }
`;
export const StateContainer = styled.div`
  margin-bottom: 0.5rem;
`;
export const Flag = styled.img`
  position: absolute;
  top: 0;
  left: 1rem;
`;
export const State = styled.p<IWithState>`
  color: var(--ocuped-hu);
  ${({ state, isReserved }) =>
    state !== "reserved" &&
    isReserved &&
    css`
      ::after {
        content: "/reservado";
        color: var(--reserved-hu);
      }
    `}
`;
export const Guest = styled.p`
  color: var(--primary-color);
  margin-bottom: 0.5rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 280px;
`;
export const TotalCost = styled.p`
  color: var(--primary-color);
  margin: 0.5rem 0;
`;
